import styled from 'styled-components';
import { headingFont } from '@/styles/mixins';

export const PageContent = styled.div<{ $wide?: boolean }>`
  padding: ${({ theme }) => theme.spacing[6]};
  max-width: ${({ $wide, theme }) => ($wide ? 'none' : theme.layout.contentMaxWidth)};
  margin: 0 auto;

  @media (max-width: 767.98px) {
    padding: ${({ theme }) => theme.spacing[4]};
  }
`;

export const PageHeaderRoot = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing[6]};
  padding-bottom: ${({ theme }) => theme.spacing[5]};
  border-bottom: 2px solid ${({ theme }) => theme.colors.accent100};
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 767.98px) {
    flex-direction: column;
    align-items: flex-start;
    gap: ${({ theme }) => theme.spacing[3]};
  }
`;

export const PageTitle = styled.h1`
  ${headingFont}
  font-size: ${({ theme }) => theme.fontSizes['2xl']};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  margin: 0;
  letter-spacing: -0.01em;

  @media (max-width: 767.98px) {
    font-size: ${({ theme }) => theme.fontSizes.xl};
  }
`;

export const PageSubtitle = styled.p`
  font-size: 0.9375rem;
  color: ${({ theme }) => theme.colors.textSecondary};
  margin-top: ${({ theme }) => theme.spacing[1]};
  margin-bottom: 0;
`;

export const PageActions = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing[3]};

  @media (max-width: 767.98px) {
    width: 100%;
    flex-wrap: wrap;
  }
`;
